import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { MftPreviewDialogResult } from '@feature/preview-mode/mft-preview-mode/models/mft-preview-dialog-result';

@Injectable()
export class PreviewModeService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) { }

  enterMftPreviewMode(info: MftPreviewDialogResult): Observable<boolean> {
    const url = this.urlBuilder.getUrl('previewmode/mft');

    return this.http
      .post(url, info).pipe(
        map(() => true)
      );
  }

  enterMfsPreviewMode(supplier: number, creditor: number, user: number): Observable<boolean> {

    const body = {
      previewAsUserId: user,
      supplerRef: supplier,
      creditorUri: creditor
    };

    const url = this.urlBuilder.getUrl('previewmode/mfs');

    return this.http
      .post(url, body).pipe(
        map(() => true)
      );
  }


  enterMciPreviewMode(clientRef: number, clientParentRef: number): Observable<boolean> {
    const url = this.urlBuilder.getUrl('previewmode/mci');
    return this.http
      .post(url, { ClientRef: clientRef, ClientParentRef: clientParentRef }).pipe(
        map(() => true)
      );
  }

  exitPreviewMode(): Observable<boolean> {
    const url = this.urlBuilder.getUrl('previewmode/exit');
    return this.http
      .post(url, {}).pipe(
        map(() => true)
      );
  }

}
